import styled, { css } from '../../../../styles/theme';
import { ButtonStyled } from '../../ButtonStyled';
import { rem } from 'polished';

export const ButtonStyledOV = styled(ButtonStyled)`
    padding: ${rem(10)} ${rem(65)};

    &:hover {
        transition: all 0.3s ease;
    }

    ${({ primary }) =>
        primary &&
        css`
            color: ${({ theme }) => theme.colors.white};
            border: 4px solid ${({ theme }) => theme.colors.primary};
            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primaryHover};
                color: ${({ theme }) => theme.colors.primary};
            }
        `}

    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.primary};
            border: 2px solid ${({ theme }) => theme.colors.primary};
            background: ${({ theme }) => theme.colors.white};
            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primary};
                color: ${({ theme }) => theme.colors.white};
            }
        `}

    ${({ primary, disabled }) =>
        primary &&
        disabled &&
        css`
            border-color: ${({ theme }) => theme.colors.primaryDisabled};
        `}

    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            background: ${({ theme }) => theme.colors.secondaryDisabled};
            border-color: ${({ theme }) => theme.colors.secondaryDisabled};
            color: ${({ theme }) => theme.colors.white};
        `}

    ${({ outline }) =>
        outline &&
        css`
            background: ${({ theme }) => theme.colors.secondaryHover};
            border: 1px solid currentColor;
            color: ${({ theme }) => theme.colors.black};
            font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
            padding: ${rem(10)} ${rem(25)};

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.white};
                color: ${({ theme }) => theme.colors.primary};
            }
        `}
`;
